/* UNSAID — Theme JS v4.0 */

// ── Scroll reveal ──────────────────────────────────────
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  els.forEach(function (el) { io.observe(el); });
})();

// ── Saveable confirmation for the online withdrawal function ─
(function () {
  var form = document.getElementById('WithdrawalForm');
  var storageKey = 'unsaid-withdrawal-confirmation';

  if (form) {
    form.addEventListener('submit', function () {
      var email = form.querySelector('input[name="contact[email]"]');
      var order = form.querySelector('input[name="contact[Bestelnummer]"]');
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          email: email ? email.value : '',
          order: order ? order.value : '',
          submittedAt: new Date().toISOString()
        }));
      } catch (error) {
        // The Shopify confirmation still works when browser storage is disabled.
      }
    });
  }

  var confirmation = document.querySelector('[data-withdrawal-confirmation]');
  if (!confirmation) return;

  var saved = {};
  try {
    saved = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
  } catch (error) {
    saved = {};
  }

  var reference = confirmation.querySelector('[data-withdrawal-reference]');
  var submittedAt = saved.submittedAt ? new Date(saved.submittedAt) : new Date();
  var dateText = submittedAt.toLocaleString('nl-NL', {
    dateStyle: 'long',
    timeStyle: 'short'
  });

  if (reference && saved.order) {
    reference.textContent = 'BESTELNUMMER: ' + saved.order;
  }

  var download = confirmation.querySelector('[data-withdrawal-download]');
  if (!download) return;

  download.addEventListener('click', function () {
    var lines = [
      'UNSAID — BEVESTIGING HERROEPING',
      '',
      'Ontvangen op: ' + dateText,
      'Bestelnummer: ' + (saved.order || 'niet beschikbaar'),
      'E-mailadres: ' + (saved.email || 'niet beschikbaar'),
      '',
      'Je digitale verzoek om de online aankoop ongedaan te maken is ontvangen.',
      'Bewaar deze bevestiging bij je administratie.'
    ];
    var file = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
    var url = URL.createObjectURL(file);
    var link = document.createElement('a');
    link.href = url;
    link.download = 'UNSAID-herroeping-' + (saved.order || 'bevestiging').replace(/[^a-z0-9-]/gi, '') + '.txt';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  });
})();

// ── Signature motion and navigation ───────────────────
(function () {
  document.documentElement.classList.add('js');

  var nav = document.querySelector('.nav');
  var progress = document.querySelector('.site-progress span');
  var updateScroll = function () {
    var top = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (nav) nav.classList.toggle('is-scrolled', top > 28);
    if (progress) {
      var max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      progress.style.setProperty('--scroll-progress', Math.min(100, (top / max) * 100) + '%');
    }
  };
  window.addEventListener('scroll', updateScroll, { passive: true });
  updateScroll();
})();

// ── Hero light follows the viewer (desktop only) ───────
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hero = document.querySelector('[data-hero]');
  if (!canHover || !hero) return;

  hero.addEventListener('pointermove', function (event) {
    var bounds = hero.getBoundingClientRect();
    var x = (event.clientX - bounds.left) / bounds.width - .5;
    var y = (event.clientY - bounds.top) / bounds.height - .5;
    hero.style.setProperty('--hero-photo-x', (x * 13) + 'px');
    hero.style.setProperty('--hero-photo-y', (y * 10) + 'px');
    hero.style.setProperty('--hero-orb-x', (x * 34) + 'px');
    hero.style.setProperty('--hero-orb-y', (y * 28) + 'px');
  });
  hero.addEventListener('pointerleave', function () {
    hero.style.setProperty('--hero-photo-x', '0px');
    hero.style.setProperty('--hero-photo-y', '0px');
    hero.style.setProperty('--hero-orb-x', '0px');
    hero.style.setProperty('--hero-orb-y', '0px');
  });
})();

// ── Small editorial tilt on campaign images ────────────
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;
  var cards = document.querySelectorAll('[data-tilt]');
  cards.forEach(function (card) {
    card.addEventListener('pointermove', function (event) {
      var bounds = card.getBoundingClientRect();
      var x = (event.clientX - bounds.left) / bounds.width - .5;
      var y = (event.clientY - bounds.top) / bounds.height - .5;
      card.style.transition = 'transform .18s ease-out';
      card.style.transform = 'perspective(1000px) rotateX(' + (-y * 1.8) + 'deg) rotateY(' + (x * 1.8) + 'deg) translateY(-2px)';
    });
    card.addEventListener('pointerleave', function () {
      card.style.transition = 'transform .55s cubic-bezier(.16,1,.3,1)';
      card.style.transform = '';
    });
  });
})();

// ── Refined button response ────────────────────────────
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;
  document.querySelectorAll('.magnetic').forEach(function (button) {
    button.addEventListener('pointermove', function (event) {
      var bounds = button.getBoundingClientRect();
      var x = (event.clientX - bounds.left) / bounds.width - .5;
      var y = (event.clientY - bounds.top) / bounds.height - .5;
      button.style.transition = 'transform .18s ease-out';
      button.style.transform = 'translate3d(' + (x * 4) + 'px,' + (y * 3) + 'px,0)';
    });
    button.addEventListener('pointerleave', function () {
      button.style.transition = 'transform .45s cubic-bezier(.16,1,.3,1)';
      button.style.transform = '';
    });
  });
})();

// ── Product gallery: swipe, arrows and counter ─────────
(function () {
  document.querySelectorAll('[data-gallery-track]').forEach(function (track) {
    var gallery = track.closest('.shop-page__gallery');
    var slides = track.querySelectorAll('.shop-page__slide');
    var previous = gallery && gallery.querySelector('[data-gallery-prev]');
    var next = gallery && gallery.querySelector('[data-gallery-next]');
    var counter = gallery && gallery.querySelector('[data-gallery-count]');
    if (!slides.length) return;

    var active = 0;
    var format = function (number) { return String(number).padStart(2, '0'); };
    var update = function () {
      if (counter) counter.textContent = format(active + 1) + ' / ' + format(slides.length);
    };
    var moveTo = function (index) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[active].offsetLeft, behavior: 'smooth' });
      update();
    };

    if (previous) previous.addEventListener('click', function () { moveTo(active - 1); });
    if (next) next.addEventListener('click', function () { moveTo(active + 1); });

    // Touch devices use the browser's native momentum swipe. Fine pointers can
    // drag the same gallery, making the interaction consistent on a laptop.
    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragStartActive = 0;
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = true;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      dragStartActive = active;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      event.preventDefault();
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });
    var finishDrag = function (event) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      var distance = event.clientX - dragStartX;
      if (Math.abs(distance) > 45) moveTo(dragStartActive + (distance < 0 ? 1 : -1));
      else moveTo(dragStartActive);
    };
    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); moveTo(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); moveTo(active + 1); }
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var nearest = 0;
        var smallest = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < smallest) { smallest = distance; nearest = index; }
        });
        active = nearest;
        update();
        ticking = false;
      });
    }, { passive: true });
    update();
  });
})();

// ── Visual size buttons retain Shopify's native selector ─
(function () {
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    if (!form) return;
    var select = form.querySelector('select[name="id"]');
    var price = form.closest('.shop-page__details') && form.closest('.shop-page__details').querySelector('[data-product-price]');
    var stock = form.closest('.shop-page__details') && form.closest('.shop-page__details').querySelector('[data-product-stock]');
    var buy = form.querySelector('[data-add-to-bag]');
    var options = picker.querySelectorAll('[data-variant-option]');
    if (!select || !options.length) return;

    var activate = function (option) {
      options.forEach(function (item) {
        var selected = item === option;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      select.value = option.getAttribute('data-variant-id');
      if (price) price.textContent = option.getAttribute('data-variant-price');
      var available = option.getAttribute('data-variant-available') === 'true';
      if (stock) stock.textContent = available ? 'BEPERKTE VOORRAAD — KLAAR VOOR VERZENDING' : 'MOMENTEEL UITVERKOCHT';
      if (buy) {
        buy.disabled = !available;
        buy.textContent = available ? 'IN WINKELWAGEN — ' + option.getAttribute('data-variant-price') : 'UITVERKOCHT';
      }
    };

    options.forEach(function (option) {
      option.addEventListener('click', function () { activate(option); });
    });
    select.addEventListener('change', function () {
      options.forEach(function (option) {
        if (option.getAttribute('data-variant-id') === select.value) activate(option);
      });
    });
    form.addEventListener('submit', function () {
      if (buy && !buy.disabled) {
        buy.classList.add('is-adding');
        buy.textContent = 'TOEVOEGEN AAN WINKELWAGEN…';
      }
    });
  });
})();
